module.exports = __webpack_public_path__ + "src/app/assets/images/icons/enroll_users.svg";